import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ec-match-job-details',
  templateUrl: 'ec-match-job-details.component.html',
  styleUrls: ['ec-match-job-details.component.css'],
})
export class ECMatchJobDetailsComponent implements OnInit {
  _isECJob: boolean;
  @Input('isECJob')
  set isECJob(value: boolean) {
    this._isECJob = value;
  }
  get isECJob(): boolean {
    return this._isECJob;
  }

  _orderInfo: any;
  @Input('orderInfo')
  set orderInfo(value: any) {
    this._orderInfo = value;
  }
  get orderInfo(): any {
    return this._orderInfo;
  }

  ngOnInit() {}
}
